import React, { useEffect, useState } from 'react';
import Container from '../container/main'
import Title from '../title/main'
import RecordTablePc from '../table-pc/main';
import RecordTableM from '../table-m/main';
import { isMobile } from 'components/select/utils';
import { getOrderData } from '@services/my-home';
import { MainOrderItem, productInfoItem } from 'pages/offical/personal/const';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone'; // dependent on utc plugin
import { useTranslation } from 'hooks/use-translation';
dayjs.extend(utc);
dayjs.extend(timezone);

function TransactionRecord() {

	const [listData, setListData] = useState<MainOrderItem[]>()
	const { transData } = useTranslation('profile')
	const handleOrderTime = (orderTime: string): string => {
		return dayjs.tz(orderTime, 'Asia/Shanghai').local().format('YYYY/MM/DD HH:mm:ss')
	}


	useEffect(() => {
		getOrderData({ pageNo: 1, pageSize: 100 }).then((res: any) => {
			const list = res.data.orderInfoDtoList || []
			if (list.length) {
				for (let i = 0; i < list.length; i++) {
					list[i].orderTime = handleOrderTime(list[i].orderTime)
					list[i].orderContent = list[i].productInfoDto.map((item: productInfoItem) => item.productName).join(',')
				}
			}
			setListData(list)
		})
	}, [])

	return (
		<Container>
			<Title>{transData.transRecord}</Title>
			{isMobile() ? <RecordTableM record={listData} transData={transData} /> : <RecordTablePc record={listData} transData={transData} />}
		</Container>
	)
}

export default TransactionRecord
